import { COLLECTION } from '../constants/routes'
import { CardItemModel } from '../types/flo-experience'

export enum ActionType {
  LINK = 'LINK',
  PLAYBACK = 'PLAYBACK',
  NONE = 'NONE',
}

export const getActionType = (data: CardItemModel): ActionType => {
  if (!data?.action) {
    return ActionType.NONE
  }

  return data.action.content_metadata ? ActionType.PLAYBACK : ActionType.LINK
}

export const getPaginateUrl = (url: string): string => {
  const collectionUrl = url
  const encodedUrl = encodeURIComponent(collectionUrl)
  return COLLECTION.replace(':url', encodedUrl)
}

export const createQueryParams = (params): string => {
  const queryString = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
    .join('&')

  return queryString ? `?${queryString}` : ''
}
